export default __webpack_public_path__ + "static/media/stake-image.d93be9ed.png";